import { capitalize } from 'lodash'
import { ComponentType, PureComponent } from 'react'
import { connect } from 'react-redux'
import StoryPreviews from 'shared/components/story/grid-previews'
import { TitleLarge } from 'shared/components/text-elements'
import { fetchMoreStories, fetchUserStories, getUsernameFromStories } from 'shared/redux/fetch-stories'
import { getAutoPlay, getStoriesByUsername } from 'shared/redux/reducers'
import { IStory, StoryResult } from 'shared/types/story'
import styled from 'styled-components'
import ChannelInfoEnhanced from './channel-info'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import withLocationState from 'shared/components/with-location-state'

const grid9 = 776
const grid3 = 248

const GRID_WIDTH = grid9

const Container = styled.div`
    display: flex;
    padding-top: 30px;
    width: 100%;
`

const Sidebar = styled.div`
    width: ${grid3}px;
`

const StoryContainer = styled.div`
    margin-left: auto;
    width: ${grid9}px;
`
const Title = styled(TitleLarge)`
    text-align: left;
    margin: 0 0 20px;
`

const StoriesView = ({ displayName, stories, autoPlay, onLoadMore, channelId, isOwner }) => {
    return (
        <Container>
            <Sidebar>
                <ChannelInfoEnhanced channelId={channelId} isOwner={isOwner} />
            </Sidebar>
            <StoryContainer>
                <Title>{capitalize(displayName)} Stories</Title>
                <StoryPreviews
                    stories={stories}
                    columns={3}
                    autoPlay={autoPlay}
                    width={GRID_WIDTH}
                    showEditMenu={true}
                    onLoadMore={onLoadMore}
                />
            </StoryContainer>
        </Container>
    )
}

const Stories = connect((state, { username, displayName }: { username: string; displayName: string }) => ({
    // Add watched stories filter when/if needed
    // const loggedInUser = selectors.getUser(state)
    // const isOwner = loggedInUser && channel.user && loggedInUser.username === channel.user.username
    // getStoriesByUsername(state, channel.user.username, isOwner ? [] : watchedStories
    stories: getStoriesByUsername(state, username),
    autoPlay: getAutoPlay(state),
    displayName: displayName,
}))(StoriesView)

type Props = {
    fetchUserStories: (username: string) => StoryResult
    fetchMoreStories: (username: string) => StoryResult
    autoPlay: boolean
    stories: IStory[]
    username: string
    isOwner: boolean
    channelId: number
}

type State = {
    isFetching: boolean
    username: string
    displayName: string
}
@withLocationState(['is_owner', 'channel_id'])
class ChannelStories extends PureComponent<Props, State> {
    state = {
        isFetching: false,
        username: this.props.username,
        displayName: '',
    }
    async componentDidMount() {
        const { fetchUserStories } = this.props
        const { username } = this.state
        // case insensitive request for user stories
        const stories = await fetchUserStories(username)
        // username can now have a different casing, update the state with the story username
        this.setState({ ...getUsernameFromStories(stories) })
    }

    onLoadMore = async () => {
        const { isFetching } = this.state
        if (isFetching) return
        const { username } = this.state
        const { fetchMoreStories } = this.props
        this.setState({ isFetching: true })
        await fetchMoreStories(username)
        this.setState({ isFetching: false })
    }

    render() {
        const { username, displayName } = this.state
        const { channelId, isOwner } = this.props
        return (
            <Stories
                username={username}
                displayName={displayName}
                onLoadMore={this.onLoadMore}
                channelId={channelId}
                isOwner={isOwner}
            />
        )
    }
}

export default connect(undefined, { fetchUserStories, fetchMoreStories })(ChannelStories as ComponentType)
